<template>
  <div class="payload-text" :class="isMe() ? 'me' : 'other'">
    <table>
      <tr v-if="isMe()">
        <td>
          <span class="time">{{
            conversation.createdAt | timeChatFormat
          }}</span>
          <span
            class="message"
            v-html="linkify(conversation.message.payload.message)"
          ></span>
        </td>
      </tr>
      <tr v-else>
        <td class="fix-width"><div class="logo-small"></div></td>
        <td>
          <span
            class="message message-left"
            v-html="linkify(conversation.message.payload.message)"
          ></span>
          <span class="time time-left">{{
            conversation.createdAt | timeChatFormat
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>
<style lang="scss" scoped>
.message-left {
  margin-left: 5px;
}
.time-left {
  line-height: 4;
}
</style>
<script>
export default {
  name: 'PayloadText',
  props: {
    conversation: Object
  },
  methods: {
    isMe() {
      return this.conversation.sender === 'customer'
    },
    // validUrl(string) {
    //   try {
    //     new URL(string)
    //   } catch (_) {
    //     return string
    //   }

    //   return `<a href="${string}" target="_blank">${string}</a>`
    // }

    linkify(inputText) {
      var replacedText, replacePattern1, replacePattern2, replacePattern3

      //URLs starting with http://, https://, or ftp://
      replacePattern1 = /(\b(https?|ftp):[-A-Z0-9+&@#%?=~_|!:,.;]*[-A-Z0-9+&@#%=~_|])/gim
      replacedText = inputText.replace(
        replacePattern1,
        '<a href="$1" target="_blank">$1</a>'
      )

      //URLs starting with "www." (without // before it, or it'd re-link the ones done above).
      replacePattern2 = /(^|[^])(www\.[\S]+(\b|$))/gim
      replacedText = replacedText.replace(
        replacePattern2,
        '$1<a href="//$2" target="_blank">$2</a>'
      )

      //Change email addresses to mailto:: links.
      replacePattern3 = /(([a-zA-Z0-9])+@[a-zA-Z]+?(\.[a-zA-Z]{2,6})+)/gim
      replacedText = replacedText.replace(
        replacePattern3,
        '<a href="mailto:$1">$1</a>'
      )

      return replacedText
    }
  }
}
</script>
